var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconanalyticspanRightOutline = function SvgIconanalyticspanRightOutline(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Analytics/icon.analytics.pan_right_outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Analytics/icon.analytics.pan_right_outline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.06666667,15.2 L19.4,2.2 C19.8418278,1.86862915 20.4686292,1.9581722 20.8,2.4 C20.9298221,2.57309617 21,2.78362979 21,3 L21,9 C21,9.55228475 21.4477153,10 22,10 L30,10 C30.5522847,10 31,10.4477153 31,11 L31,21 C31,21.5522847 30.5522847,22 30,22 L22,22 C21.4477153,22 21,22.4477153 21,23 L21,29 C21,29.5522847 20.5522847,30 20,30 C19.7836298,30 19.5730962,29.9298221 19.4,29.8 L2.06666667,16.8 C1.62483887,16.4686292 1.53529582,15.8418278 1.86666667,15.4 C1.92352092,15.3241943 1.990861,15.2568542 2.06666667,15.2 Z",
    id: "Path-15",
    stroke: "#09BE86",
    strokeWidth: 2,
    transform: "translate(16.000000, 16.000000) rotate(-180.000000) translate(-16.000000, -16.000000) "
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconanalyticspanRightOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.analytics.pan_right_outline.10ff87b2dca2f4ebf692a03d881c4365.svg";